export default __webpack_public_path__ + "static/media/add-objective.e2147889.svg";